import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table
} from "reactstrap";

const InvoiceTab = () => {
  const [filters, setFilters] = useState({
    fromServiceDate: "",
    toServiceDate: "",
  });

  const [invoices] = useState([
    {
      dateOfService: "27/06/2025",
      invoiceNo: "2506/000022",
      invoiceDate: "27/06/2025",
      patient: "MUSA NGOETJANA",
      status: "Cash",
      invoiceTotal: "R 1,500.00",
      medAidLiable: "R 0.00",
      patientLiable: "R 1,500.00"
    }
  ]);

  const handleInputChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              {/* Filters */}
              <Row className="align-items-end">
                <Col lg={6}>
                 <div className="mb-3">
                    <Label>Date From</Label>
                  <Input
                    type="date"
                    name="fromServiceDate"
                    value={filters.fromServiceDate}
                    onChange={handleInputChange}
                  />
                 </div>
                  
                </Col>
                <Col lg={6}>
                <div className="mb-3"><Label>Date To</Label>
                  <Input
                    type="date"
                    name="toServiceDate"
                    value={filters.toServiceDate}
                    onChange={handleInputChange}
                  /></div>
                  
                </Col>
                
              </Row>

              <Row className="mt-1">
                <Col lg={3}>
                  
                </Col>
                <Col lg={9} className="d-flex align-items-end justify-content-end">
                  <Button color="secondary" className="me-2">
                    Clear
                  </Button>
                  <Button color="warning">Search</Button>
                </Col>
              </Row>


              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div>
                  {/* <Button color="link" disabled>
                    «
                  </Button>
                  <Button color="link" active>
                    1
                  </Button>
                  <Button color="link" disabled>
                    »
                  </Button> */}
                </div>
                <Button color="dark">Close</Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default InvoiceTab;
